// extracted by mini-css-extract-plugin
export default {"withoutSearch":"style_withoutSearch__VTkyZ"};